export interface OAuthProviderInfo {
  /** Display name shown in "Connected with <displayName>" */
  displayName: string;
  /** Tailwind-safe hex string for the logo tile background */
  brandColor: string;
  /** Single-letter monogram for the tile (fallback for missing SVG) */
  letter: string;
}

export const OAUTH_PROVIDERS: Record<string, OAuthProviderInfo> = {
  google_ads:        { displayName: 'Google',     brandColor: '#4285F4', letter: 'G' },
  google_analytics:  { displayName: 'Google',     brandColor: '#4285F4', letter: 'G' },
  google_sheets:     { displayName: 'Google',     brandColor: '#4285F4', letter: 'G' },
  hubspot:           { displayName: 'HubSpot',    brandColor: '#FF7A59', letter: 'H' },
  linkedin_ads:      { displayName: 'LinkedIn',   brandColor: '#0A66C2', letter: 'L' },
  twitter_ads:       { displayName: 'X',          brandColor: '#000000', letter: 'X' },
  snapchat_ads:      { displayName: 'Snapchat',   brandColor: '#FFFC00', letter: 'S' },
  reddit_ads:        { displayName: 'Reddit',     brandColor: '#FF4500', letter: 'R' },
  tiktok_ads:        { displayName: 'TikTok',     brandColor: '#000000', letter: 'T' },
  meta_ads:          { displayName: 'Meta',       brandColor: '#1877F2', letter: 'M' },
  amazon_dsp:        { displayName: 'Amazon',     brandColor: '#FF9900', letter: 'A' },
  bing_ads:          { displayName: 'Microsoft',  brandColor: '#0078D4', letter: 'M' },
};

export function getOAuthProvider(key: string): OAuthProviderInfo {
  return OAUTH_PROVIDERS[key] ?? { displayName: 'Unknown', brandColor: '#666666', letter: '?' };
}
